// https://www.dbos.dev/dbos-pricing

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { SlideIn } from '@components/interactions';

export function DbosPricingPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <div className="new-pricing-section">
        <section className="section_pricing">
          <SlideIn className="padding-global" as="div">
            <div className="container-large">
              <div className="padding-section-medium">
                <div className="pricing_component">
                  <div className="margin-bottom margin-small">
                    <div className="text-align-center">
                      <div className="max-width-medium">
                        <div className="margin-bottom margin-small">
                          <h1 className="heading-style-h1">DBOS Pricing</h1>
                        </div>
                        <p className="text-body-active pricing-page-subheading">
                          Support, tooling, and advanced features for scaling DBOS Transact applications.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SlideIn>
        </section>
        <section id="plans" className="section_layout-benefits">
          <SlideIn className="padding-global" as="div">
            <div className="container-large">
              <div className="padding-section-small">
                <div className="add-on_component">
                  <div className="w-layout-grid layout252_list">
                    <div id="w-node-_24fda79a-0345-1b0f-5c13-d8a8fbb0b821-74254d3b" className="layout-2col_item">
                      <div className="pricing_item-header">
                        <div className="margin-bottom margin-small">
                          <div className="margin-bottom margin-xsmall">
                            <div className="layout_benefit-item">
                              <h3 className="heading-style-h5 text-weight-medium">DBOS Pro</h3>
                            </div>
                          </div>
                          <div className="text-body-active text-size-regular">
                            {'DBOS\u00a0support & tooling for startups and individuals.'}
                          </div>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div data-wf--button--variant="primary-large" className="button-wrapper">
                            <a href="https://console.dbos.dev/" className="button w-inline-block">
                              <div className="text-block-4">Start free trial</div>
                              <div className="icon-chevron-right w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                        <h4 className="heading-style-h3">
                          $99<span className="heading-style-h6 is-pricing">/month</span>
                        </h4>
                        <div className="margin-vertical margin-small">
                          <div className="divider-horizontal" />
                        </div>
                      </div>
                      <div className="pricing_feature-list">
                        <div id="w-node-_343ac2d2-5fdc-a0e2-1678-2b6658f1b767-74254d3b" className="pricing_menu">
                          <div>Included Monthly Usage</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>2 user seats</div>
                        </div>
                        <div id="w-node-_343ac2d2-5fdc-a0e2-1678-2b6658f1b75d-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Manage up to 3 DBOS apps</div>
                        </div>
                        <div id="w-node-_343ac2d2-5fdc-a0e2-1678-2b6658f1b762-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>
                            {'Record & manage 1 million checkpoints (workflows, steps, transactions) per month'}
                          </div>
                        </div>
                        <div id="w-node-_2a4a8793-8f5b-6386-93ad-dd153b9a1c24-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Extra checkpoints - $50 per million</div>
                        </div>
                        <div id="w-node-ca6a75bc-cdd4-4001-96a8-7ae9a793b517-74254d3b" className="pricing_menu is-last">
                          <div>Features</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Access to DBOS Conductor</div>
                        </div>
                        <div id="w-node-b3677cd1-3a5e-9acd-600e-b6aeadb52db6-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Workflow management console</div>
                        </div>
                        <div id="w-node-a52bba48-a7ea-04a5-4879-592472aacd70-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Workflow data retention policies</div>
                        </div>
                        <div id="w-node-bc5768fc-2aee-5f01-7cc3-3e9ad9e95a1f-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Distributed workflow recovery</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Automatic workflow version upgrade</div>
                        </div>
                        <div id="w-node-a35d23ef-34d9-5e84-5484-8f7e9fc52d60-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Unlimited throughput and concurrency</div>
                        </div>
                        <div id="w-node-_0f94593f-5464-f7a2-bc85-55de19634227-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Unlimited connected workers</div>
                        </div>
                        <div id="w-node-ccb5f305-e49a-4b6d-6c62-61e900d13512-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>MCP Server</div>
                        </div>
                        <div id="w-node-b3a5c71e-d2a3-eb62-2693-3d8b4e3a1feb-74254d3b" className="pricing_menu is-last">
                          <div>Support</div>
                        </div>
                        <div id="w-node-_343ac2d2-5fdc-a0e2-1678-2b6658f1b771-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Community support via Discord</div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-_24fda79a-0345-1b0f-5c13-d8a8fbb0b839-74254d3b"
                      className="layout-2col_item is-popular"
                    >
                      <div className="pricing_item-header">
                        <div className="margin-bottom margin-small">
                          <div className="margin-bottom margin-xsmall">
                            <div className="is-popular">
                              <div className="layout_benefit-item">
                                <h3 className="heading-style-h5 text-weight-medium">DBOS Teams</h3>
                              </div>
                              <div className="tagline-container is-pricing">
                                <div className="text-style-tagline">Most Popular</div>
                              </div>
                            </div>
                          </div>
                          <div className="text-body-active text-size-regular">
                            {'Premium support & tooling for larger teams & systems.'}
                          </div>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div data-wf--button--variant="primary-large" className="button-wrapper">
                            <a href="https://console.dbos.dev/?teams" className="button w-inline-block">
                              <div className="text-block-4">Start free trial</div>
                              <div className="icon-chevron-right w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                        <h4 className="heading-style-h3">
                          $499<span className="heading-style-h6 is-pricing">/month</span>
                        </h4>
                        <div className="margin-vertical margin-small">
                          <div className="divider-horizontal" />
                        </div>
                      </div>
                      <div className="pricing_feature-list">
                        <div id="w-node-c7f76919-e8ed-1eaa-cbfd-fb1f56571623-74254d3b" className="pricing_menu">
                          <div>Included Monthly Usage</div>
                        </div>
                        <div id="w-node-_54c87a49-7387-6a9d-6f5e-dd0e045b60e5-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>10 user seats</div>
                        </div>
                        <div id="w-node-_9031c87b-4abf-4b8d-3496-bd83a42d301e-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Manage 10 DBOS apps</div>
                        </div>
                        <div id="w-node-_922b9c08-e3d6-7085-f84c-6584e2d6206d-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Extra apps - $50 each</div>
                        </div>
                        <div id="w-node-_705e0d24-3847-1d6e-745a-5eac2a311755-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>10M free checkpoints</div>
                        </div>
                        <div id="w-node-_117d6f57-94f8-ef0d-9803-cd3cb96dc0ea-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Extra checkpoints - $40 per million</div>
                        </div>
                        <div id="w-node-_713c8a0a-8237-fff6-6771-97376cacd797-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Quantity discounts available</div>
                        </div>
                        <div className="pricing_menu is-last">
                          <div>Features</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Everything in DBOS Pro</div>
                        </div>
                        <div id="w-node-_54c87a49-7387-6a9d-6f5e-dd0e045b60e0-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Custom workflow alerting</div>
                        </div>
                        <div id="w-node-c95b79db-a8ad-80db-8a89-9f907caa475b-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Role-based access control</div>
                        </div>
                        <div id="w-node-_158c1353-4ec9-dd2a-5249-2511518a08f2-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>OpenMetrics support</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Metadata-only mode</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>{'SOC 2 Type 2 &\u00a0HIPAA'}</div>
                        </div>
                        <div
                          id="w-node-_0037a096-586d-82a1-e6cf-94c50f31126b-74254d3b"
                          className="pricing_menu is-last"
                        >
                          <div>Support</div>
                        </div>
                        <div id="w-node-_8f28e5b2-3318-dad7-0c26-8ebd355f2fb4-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Dedicated Slack support channel</div>
                        </div>
                        <div id="w-node-_54c87a49-7387-6a9d-6f5e-dd0e045b60d6-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Priority email support</div>
                        </div>
                        <div id="w-node-_54c87a49-7387-6a9d-6f5e-dd0e045b60ef-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>2-day response SLAs</div>
                        </div>
                        <div id="w-node-_54c87a49-7387-6a9d-6f5e-dd0e045b60ea-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Application architecture assistance</div>
                        </div>
                      </div>
                    </div>
                    <div id="w-node-_8be6236c-51b3-7ef1-630d-611f099217ca-74254d3b" className="layout-2col_item">
                      <div className="pricing_item-header">
                        <div className="margin-bottom margin-small">
                          <div className="margin-bottom margin-xsmall">
                            <div className="layout_benefit-item">
                              <h3 className="heading-style-h5 text-weight-medium">{'DBOS\u00a0Enterprise'}</h3>
                            </div>
                          </div>
                          <div className="text-body-active text-size-regular">
                            Custom pricing and self-hosted Conductor options for enterprises.
                          </div>
                        </div>
                        <div className="margin-bottom margin-xsmall is-pricing">
                          <div
                            data-wf--button--variant="secondary-large"
                            className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                          >
                            <a
                              href="/contact"
                              className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                            >
                              <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">
                                Contact us
                              </div>
                              <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                        <h4 className="heading-style-h3">Custom</h4>
                        <div className="margin-vertical margin-small">
                          <div className="divider-horizontal" />
                        </div>
                      </div>
                      <div className="pricing_feature-list">
                        <div id="w-node-a698fa7c-d589-d5d2-6290-53ee926f9519-74254d3b" className="pricing_menu">
                          <div>Features</div>
                        </div>
                        <div id="w-node-_0800ed76-3792-90ef-fe4d-4bb72e25b8f6-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Everything in DBOS Teams</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Support for sharded Postgres</div>
                        </div>
                        <div id="w-node-e2af716a-bd60-c46d-d79d-44ae5eccb217-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>SSO/SAML</div>
                        </div>
                        <div id="w-node-a698fa7c-d589-d5d2-6290-53ee926f951e-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Quantity discounts available</div>
                        </div>
                        <div className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Unlimited plans available</div>
                        </div>
                        <div id="w-node-a698fa7c-d589-d5d2-6290-53ee926f9523-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Option to self-host DBOS Conductor</div>
                        </div>
                        <div id="w-node-b437a97f-0e26-cc43-c6d0-a52d095c1f2f-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Run in air-gapped environments</div>
                        </div>
                        <div id="w-node-_0e8b5eb2-9f1d-c0c3-6bb7-92effab3cf50-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Custom security questionnaires</div>
                        </div>
                        <div id="w-node-a698fa7c-d589-d5d2-6290-53ee926f9528-74254d3b" className="pricing_menu is-last">
                          <div>Support</div>
                        </div>
                        <div id="w-node-b9387cb8-ff82-4ab2-8a6c-3975c09575bb-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Same-day response SLAs</div>
                        </div>
                        <div id="w-node-_456d8224-b817-a52a-0ac8-b42ad826bf9e-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Technical onboarding</div>
                        </div>
                        <div id="w-node-a698fa7c-d589-d5d2-6290-53ee926f9532-74254d3b" className="pricing_feature">
                          <div className="pricing_icon-wrapper">
                            <div className="icon-embed-xsmall-3 w-embed">
                              <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                                  fill="currentColor"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </div>
                          <div>Technical account management</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SlideIn>
        </section>
        <section className="section_layout-benefits">
          <SlideIn className="padding-global" as="div">
            <div className="container-large">
              <div className="padding-section-large">
                <div className="pricing1_plan">
                  <div className="pricing21_col">
                    <div className="margin-bottom margin-xsmall">
                      <div className="layout_benefit-item">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M6.2868 20.1495C4.78397 20.1495 3.50422 19.6237 2.44755 18.572C1.39072 17.5203 0.862305 16.242 0.862305 14.737C0.862305 13.413 1.28097 12.2444 2.1183 11.2313C2.95564 10.2181 4.02589 9.60751 5.32905 9.39951C5.67839 7.77084 6.47805 6.44201 7.72805 5.41301C8.97805 4.38401 10.4192 3.86951 12.0516 3.86951C13.9331 3.86951 15.5254 4.55067 16.8286 5.91301C18.1319 7.27534 18.7995 8.91251 18.8313 10.8245V11.4245C20.0433 11.427 21.064 11.8428 21.8933 12.6718C22.7226 13.5009 23.1373 14.5393 23.1373 15.787C23.1373 16.9805 22.7086 18.0059 21.8513 18.8633C20.9938 19.7208 19.9683 20.1495 18.7748 20.1495H6.2868ZM6.2868 18.4463H18.7628C19.494 18.4463 20.122 18.1846 20.6468 17.6613C21.1716 17.1378 21.4341 16.509 21.4341 15.775C21.4341 15.041 21.1716 14.4123 20.6468 13.8888C20.122 13.3654 19.494 13.1038 18.7628 13.1038H17.1341V10.938C17.1341 9.43951 16.6324 8.17167 15.6291 7.13451C14.6257 6.09734 13.4002 5.57876 11.9526 5.57876C10.4961 5.57876 9.26322 6.10476 8.25406 7.15676C7.24506 8.20876 6.74055 9.49109 6.74055 11.0038H6.2118C5.1933 11.0038 4.33097 11.3609 3.6248 12.0753C2.91864 12.7894 2.56555 13.6723 2.56555 14.7238C2.56555 15.7586 2.92697 16.6378 3.6498 17.3613C4.37264 18.0846 5.25164 18.4463 6.2868 18.4463Z"
                              fill="url(#paint0_linear_8760_1514)"
                            />
                            {'\n'}
                            <defs>
                              {'\n'}
                              <linearGradient
                                id="paint0_linear_8760_1514"
                                x1="3.00883"
                                y1="3.86951"
                                x2="22.7022"
                                y2="3.86951"
                                gradientUnits="userSpaceOnUse"
                              >
                                {'\n'}
                                <stop stopColor="#C8F62E" />
                                {'\n'}
                                <stop offset="0.166667" stopColor="#87FB6B" />
                                {'\n'}
                                <stop offset="0.333333" stopColor="#3FFA9F" />
                                {'\n'}
                                <stop offset="0.5" stopColor="#00F5CC" />
                                {'\n'}
                                <stop offset="0.666667" stopColor="#00ECEC" />
                                {'\n'}
                                <stop offset="0.833333" stopColor="#48E1FE" />
                                {'\n'}
                                <stop offset="1" stopColor="#80D4FF" />
                                {'\n'}
                              </linearGradient>
                              {'\n'}
                            </defs>
                            {'\n'}
                          </svg>
                        </div>
                        <h2 className="heading-style-h6 text-align-center">DBOS Cloud</h2>
                      </div>
                    </div>
                    <div className="margin-bottom margin-xsmall">
                      <h3 className="heading-style-h3">Need app hosting?</h3>
                    </div>
                    <div className="margin-bottom margin-small">
                      <div className="text-body-active">
                        {
                          'DBOS\u00a0Cloud is a serverless code execution platform, specially built for reliable, observable DBOS\u00a0Transact applications.'
                        }
                      </div>
                    </div>
                    <div className="div-block-64">
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/contact"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">
                            Contact sales
                          </div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="pricing_feature-list is-transact">
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d60385-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>Serverless code hosting and execution</div>
                    </div>
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d6038a-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>Auto-scaling</div>
                    </div>
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d6038f-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>Built-in observability infrastructure</div>
                    </div>
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d60399-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>Automatic app recovery</div>
                    </div>
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d60394-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>SOC 2 Type 2 and HIPAA compliant</div>
                    </div>
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d6039e-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>More cost-effective than AWS Lambda</div>
                    </div>
                    <div id="w-node-e33a6862-d4df-4134-dd0a-534a09d603a3-74254d3b" className="pricing_feature">
                      <div className="pricing_icon-wrapper">
                        <div className="icon-embed-xsmall-3 w-embed">
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M20.3479 7.56384L9.7479 18.1638C9.65402 18.2585 9.52622 18.3117 9.3929 18.3117C9.25958 18.3117 9.13178 18.2585 9.0379 18.1638L3.6479 12.7738C3.55324 12.68 3.5 12.5522 3.5 12.4188C3.5 12.2855 3.55324 12.1577 3.6479 12.0638L4.3479 11.3638C4.44178 11.2692 4.56958 11.2159 4.7029 11.2159C4.83622 11.2159 4.96402 11.2692 5.0579 11.3638L9.3879 15.6938L18.9379 6.14384C19.1357 5.95205 19.4501 5.95205 19.6479 6.14384L20.3479 6.85384C20.4426 6.94772 20.4958 7.07552 20.4958 7.20884C20.4958 7.34216 20.4426 7.46995 20.3479 7.56384Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div>Integrates with DBOS Conductor</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SlideIn>
        </section>
        <section className="section_testimonial-large">
          <SlideIn className="padding-global" as="div">
            <div className="container-large">
              <div className="padding-section-small">
                <div className="testimonial_wrapper w-dyn-list">
                  <div fs-list-element="list" role="list" className="w-dyn-items">
                    <div role="listitem" className="w-dyn-item">
                      <div className="testimonial34_card">
                        <div className="testimonial34_left">
                          <img
                            fs-list-element="tab-link"
                            loading="lazy"
                            alt="Orderful"
                            src="/assets/cms/Orderful-logo-tight.svg"
                            className="testimonial34_tab-logo"
                            style={{ maxHeight: '1.75rem' }}
                          />
                          <div className="text-size-medium">
                            {
                              '“In EDI, you can’t have things fall between the cracks. You need the ability to trace it end to end, and we don’t think we could do that without DBOS.”'
                            }
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/pier-orderful.jpg"
                                alt="Piers MacDonald"
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-weight-semibold">Piers MacDonald</div>
                              <p className="text-body-active">CTO</p>
                            </div>
                          </div>
                        </div>
                        <div
                          id="w-node-_24fda79a-0345-1b0f-5c13-d8a8fbb0b87a-74254d3b"
                          style={{
                            backgroundImage: 'url("/assets/cms/DBOS-Orderful-Customer-Case-Study.jpg")',
                          }}
                          className="testimonial34_right"
                        >
                          <div className="div-block-52">
                            <div className="tagline-container">
                              <div className="text-style-tagline">Enterprise Integration Software</div>
                            </div>
                            <div className="div-block-49">
                              <h3 className="heading-style-h5 is-list">Orderful: Resilient EDI at Scale</h3>
                            </div>
                            <div
                              data-wf--button--variant="tertiary-large"
                              className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                            >
                              <a
                                href="/case-studies/orderful-resilient-edi-at-scale"
                                className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                              >
                                <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                  Read case study
                                </div>
                                <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    {'\n'}
                                    <path
                                      d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                      fill="#F3F6F8"
                                    />
                                    {'\n'}
                                  </svg>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="div-block-51" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SlideIn>
        </section>
        <section className="section_security">
          <SlideIn className="padding-global" as="div">
            <div className="container-large">
              <div className="padding-section-large">
                <div className="layout16_component">
                  <div className="w-layout-grid layout16_content">
                    <div className="layout16_content-left">
                      <div className="tagline-container">
                        <div className="text-style-tagline">Security</div>
                      </div>
                      <div className="margin-bottom margin-small">
                        <h2 className="heading-style-h2">Enterprise-grade data protection</h2>
                      </div>
                      <div className="margin-bottom margin-small">
                        <p className="text-body-active newhomebody">
                          We prioritize security, privacy, and reliability, so your team can build with confidence, not
                          manage infrastructure. Our platform meets the security and compliance standards you need to
                          run mission-critical workflows at scale, ensuring seamless execution and enterprise-grade
                          protection.
                        </p>
                      </div>
                      <div className="layout16_item-list">
                        <div id="w-node-_24fda79a-0345-1b0f-5c13-d8a8fbb0b897-74254d3b" className="layout16_item">
                          <div className="w-embed">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M41.9909 14.4665C41.9576 14.1304 41.8396 13.8082 41.648 13.5301C41.4563 13.252 41.1972 13.0271 40.8949 12.8765L24.8949 4.87647C24.617 4.73743 24.3106 4.66504 23.9999 4.66504C23.6892 4.66504 23.3827 4.73743 23.1049 4.87647L7.10486 12.8765C6.80341 13.028 6.54509 13.2531 6.35384 13.5311C6.1626 13.809 6.04463 14.1308 6.01086 14.4665C5.98886 14.6805 4.08886 36.0005 23.1889 44.4945C23.4441 44.6096 23.7209 44.6692 24.0009 44.6692C24.2809 44.6692 24.5577 44.6096 24.8129 44.4945C43.9129 36.0005 42.0129 14.6825 41.9909 14.4665ZM24.0009 40.4605C10.4629 33.9165 9.82286 19.9505 9.93286 15.9365L24.0009 8.90247L38.0589 15.9325C38.1329 19.9105 37.4029 33.9685 24.0009 40.4605Z"
                                fill="#87FB6B"
                              />
                              {'\n'}
                              <path
                                d="M41.9909 14.4665C41.9576 14.1304 41.8396 13.8082 41.648 13.5301C41.4563 13.252 41.1972 13.0271 40.8949 12.8765L24.8949 4.87647C24.617 4.73743 24.3106 4.66504 23.9999 4.66504C23.6892 4.66504 23.3827 4.73743 23.1049 4.87647L7.10486 12.8765C6.80341 13.028 6.54509 13.2531 6.35384 13.5311C6.1626 13.809 6.04463 14.1308 6.01086 14.4665C5.98886 14.6805 4.08886 36.0005 23.1889 44.4945C23.4441 44.6096 23.7209 44.6692 24.0009 44.6692C24.2809 44.6692 24.5577 44.6096 24.8129 44.4945C43.9129 36.0005 42.0129 14.6825 41.9909 14.4665ZM24.0009 40.4605C10.4629 33.9165 9.82286 19.9505 9.93286 15.9365L24.0009 8.90247L38.0589 15.9325C38.1329 19.9105 37.4029 33.9685 24.0009 40.4605Z"
                                fill="url(#paint0_linear_8350_1226)"
                              />
                              {'\n'}
                              <path
                                d="M22.0009 25.8386L17.4149 21.2526L14.5869 24.0806L22.0009 31.4946L33.4149 20.0806L30.5869 17.2526L22.0009 25.8386Z"
                                fill="#87FB6B"
                              />
                              {'\n'}
                              <path
                                d="M22.0009 25.8386L17.4149 21.2526L14.5869 24.0806L22.0009 31.4946L33.4149 20.0806L30.5869 17.2526L22.0009 25.8386Z"
                                fill="url(#paint1_linear_8350_1226)"
                              />
                              {'\n'}
                              <defs>
                                {'\n'}
                                <linearGradient
                                  id="paint0_linear_8350_1226"
                                  x1="8.65697"
                                  y1="4.66504"
                                  x2="41.3474"
                                  y2="4.66504"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  {'\n'}
                                  <stop stopColor="#C8F62E" />
                                  {'\n'}
                                  <stop offset="0.166667" stopColor="#87FB6B" />
                                  {'\n'}
                                  <stop offset="0.333333" stopColor="#3FFA9F" />
                                  {'\n'}
                                  <stop offset="0.5" stopColor="#00F5CC" />
                                  {'\n'}
                                  <stop offset="0.666667" stopColor="#00ECEC" />
                                  {'\n'}
                                  <stop offset="0.833333" stopColor="#48E1FE" />
                                  {'\n'}
                                  <stop offset="1" stopColor="#80D4FF" />
                                  {'\n'}
                                </linearGradient>
                                {'\n'}
                                <linearGradient
                                  id="paint1_linear_8350_1226"
                                  x1="8.65697"
                                  y1="4.66504"
                                  x2="41.3474"
                                  y2="4.66504"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  {'\n'}
                                  <stop stopColor="#C8F62E" />
                                  {'\n'}
                                  <stop offset="0.166667" stopColor="#87FB6B" />
                                  {'\n'}
                                  <stop offset="0.333333" stopColor="#3FFA9F" />
                                  {'\n'}
                                  <stop offset="0.5" stopColor="#00F5CC" />
                                  {'\n'}
                                  <stop offset="0.666667" stopColor="#00ECEC" />
                                  {'\n'}
                                  <stop offset="0.833333" stopColor="#48E1FE" />
                                  {'\n'}
                                  <stop offset="1" stopColor="#80D4FF" />
                                  {'\n'}
                                </linearGradient>
                                {'\n'}
                              </defs>
                              {'\n'}
                            </svg>
                          </div>
                          <div className="text-style-tagline">SOC 2 Type 2 Compliant</div>
                        </div>
                        <div id="w-node-_24fda79a-0345-1b0f-5c13-d8a8fbb0b89b-74254d3b" className="layout16_item">
                          <div className="w-embed">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M13.0321 29.313L10.0521 42.217C9.95978 42.6077 9.98748 43.0172 10.1315 43.392C10.2756 43.7667 10.5293 44.0893 10.8596 44.3176C11.1898 44.5459 11.5813 44.6693 11.9828 44.6717C12.3842 44.6741 12.7771 44.5554 13.1101 44.331L24.0001 37.071L34.8901 44.331C35.2307 44.5572 35.6325 44.6736 36.0413 44.6647C36.4501 44.6557 36.8464 44.5218 37.1768 44.2808C37.5073 44.0399 37.756 43.7036 37.8896 43.3171C38.0232 42.9307 38.0352 42.5125 37.9241 42.119L34.2661 29.319L43.3381 21.155C43.6286 20.8934 43.8361 20.5523 43.9349 20.174C44.0337 19.7957 44.0194 19.3968 43.8938 19.0265C43.7683 18.6562 43.537 18.3308 43.2285 18.0906C42.92 17.8504 42.5478 17.7059 42.1581 17.675L30.7561 16.767L25.8221 5.845C25.6647 5.49331 25.409 5.19467 25.0857 4.98512C24.7624 4.77557 24.3853 4.66406 24.0001 4.66406C23.6148 4.66406 23.2377 4.77557 22.9144 4.98512C22.5911 5.19467 22.3354 5.49331 22.1781 5.845L17.2441 16.767L5.84205 17.673C5.45896 17.7033 5.09273 17.8434 4.78716 18.0765C4.4816 18.3095 4.24964 18.6256 4.11904 18.9871C3.98844 19.3485 3.96473 19.7399 4.05074 20.1144C4.13676 20.4889 4.32885 20.8308 4.60405 21.099L13.0321 29.313ZM18.7381 20.661C19.095 20.6329 19.4379 20.5092 19.7307 20.303C20.0234 20.0968 20.2553 19.8157 20.4021 19.489L24.0001 11.527L27.5981 19.489C27.7448 19.8157 27.9767 20.0968 28.2694 20.303C28.5622 20.5092 28.9051 20.6329 29.2621 20.661L37.2061 21.291L30.6641 27.179C30.0961 27.691 29.8701 28.479 30.0781 29.215L32.5841 37.985L25.1121 33.003C24.7841 32.7829 24.398 32.6653 24.0031 32.6653C23.6081 32.6653 23.222 32.7829 22.8941 33.003L15.0861 38.209L17.1861 29.117C17.2631 28.7826 17.2527 28.434 17.156 28.1048C17.0594 27.7755 16.8796 27.4767 16.6341 27.237L10.5581 21.313L18.7381 20.661Z"
                                fill="#87FB6B"
                              />
                              {'\n'}
                              <path
                                d="M13.0321 29.313L10.0521 42.217C9.95978 42.6077 9.98748 43.0172 10.1315 43.392C10.2756 43.7667 10.5293 44.0893 10.8596 44.3176C11.1898 44.5459 11.5813 44.6693 11.9828 44.6717C12.3842 44.6741 12.7771 44.5554 13.1101 44.331L24.0001 37.071L34.8901 44.331C35.2307 44.5572 35.6325 44.6736 36.0413 44.6647C36.4501 44.6557 36.8464 44.5218 37.1768 44.2808C37.5073 44.0399 37.756 43.7036 37.8896 43.3171C38.0232 42.9307 38.0352 42.5125 37.9241 42.119L34.2661 29.319L43.3381 21.155C43.6286 20.8934 43.8361 20.5523 43.9349 20.174C44.0337 19.7957 44.0194 19.3968 43.8938 19.0265C43.7683 18.6562 43.537 18.3308 43.2285 18.0906C42.92 17.8504 42.5478 17.7059 42.1581 17.675L30.7561 16.767L25.8221 5.845C25.6647 5.49331 25.409 5.19467 25.0857 4.98512C24.7624 4.77557 24.3853 4.66406 24.0001 4.66406C23.6148 4.66406 23.2377 4.77557 22.9144 4.98512C22.5911 5.19467 22.3354 5.49331 22.1781 5.845L17.2441 16.767L5.84205 17.673C5.45896 17.7033 5.09273 17.8434 4.78716 18.0765C4.4816 18.3095 4.24964 18.6256 4.11904 18.9871C3.98844 19.3485 3.96473 19.7399 4.05074 20.1144C4.13676 20.4889 4.32885 20.8308 4.60405 21.099L13.0321 29.313ZM18.7381 20.661C19.095 20.6329 19.4379 20.5092 19.7307 20.303C20.0234 20.0968 20.2553 19.8157 20.4021 19.489L24.0001 11.527L27.5981 19.489C27.7448 19.8157 27.9767 20.0968 28.2694 20.303C28.5622 20.5092 28.9051 20.6329 29.2621 20.661L37.2061 21.291L30.6641 27.179C30.0961 27.691 29.8701 28.479 30.0781 29.215L32.5841 37.985L25.1121 33.003C24.7841 32.7829 24.398 32.6653 24.0031 32.6653C23.6081 32.6653 23.222 32.7829 22.8941 33.003L15.0861 38.209L17.1861 29.117C17.2631 28.7826 17.2527 28.434 17.156 28.1048C17.0594 27.7755 16.8796 27.4767 16.6341 27.237L10.5581 21.313L18.7381 20.661Z"
                                fill="url(#paint0_linear_8350_1309)"
                              />
                              {'\n'}
                              <defs>
                                {'\n'}
                                <linearGradient
                                  id="paint0_linear_8350_1309"
                                  x1="6.99998"
                                  y1="4.66406"
                                  x2="43.2185"
                                  y2="4.66406"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  {'\n'}
                                  <stop stopColor="#C8F62E" />
                                  {'\n'}
                                  <stop offset="0.166667" stopColor="#87FB6B" />
                                  {'\n'}
                                  <stop offset="0.333333" stopColor="#3FFA9F" />
                                  {'\n'}
                                  <stop offset="0.5" stopColor="#00F5CC" />
                                  {'\n'}
                                  <stop offset="0.666667" stopColor="#00ECEC" />
                                  {'\n'}
                                  <stop offset="0.833333" stopColor="#48E1FE" />
                                  {'\n'}
                                  <stop offset="1" stopColor="#80D4FF" />
                                  {'\n'}
                                </linearGradient>
                                {'\n'}
                              </defs>
                              {'\n'}
                            </svg>
                          </div>
                          <div className="text-style-tagline">GDPR Compliant</div>
                        </div>
                        <div id="w-node-_24fda79a-0345-1b0f-5c13-d8a8fbb0b89f-74254d3b" className="layout16_item">
                          <div className="w-embed">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M24 4.66699C18.486 4.66699 14 9.15299 14 14.667V18.667H12C9.794 18.667 8 20.461 8 22.667V40.667C8 42.873 9.794 44.667 12 44.667H36C38.206 44.667 40 42.873 40 40.667V22.667C40 20.461 38.206 18.667 36 18.667H34V14.667C34 9.15299 29.514 4.66699 24 4.66699ZM18 14.667C18 11.359 20.692 8.66699 24 8.66699C27.308 8.66699 30 11.359 30 14.667V18.667H18V14.667ZM36.004 40.667H26V36.111C27.19 35.417 28 34.141 28 32.667C28 30.461 26.206 28.667 24 28.667C21.794 28.667 20 30.461 20 32.667C20 34.139 20.81 35.417 22 36.111V40.667H12V22.667H36L36.004 40.667Z"
                                fill="#87FB6B"
                              />
                              {'\n'}
                              <path
                                d="M24 4.66699C18.486 4.66699 14 9.15299 14 14.667V18.667H12C9.794 18.667 8 20.461 8 22.667V40.667C8 42.873 9.794 44.667 12 44.667H36C38.206 44.667 40 42.873 40 40.667V22.667C40 20.461 38.206 18.667 36 18.667H34V14.667C34 9.15299 29.514 4.66699 24 4.66699ZM18 14.667C18 11.359 20.692 8.66699 24 8.66699C27.308 8.66699 30 11.359 30 14.667V18.667H18V14.667ZM36.004 40.667H26V36.111C27.19 35.417 28 34.141 28 32.667C28 30.461 26.206 28.667 24 28.667C21.794 28.667 20 30.461 20 32.667C20 34.139 20.81 35.417 22 36.111V40.667H12V22.667H36L36.004 40.667Z"
                                fill="url(#paint0_linear_8350_1247)"
                              />
                              {'\n'}
                              <defs>
                                {'\n'}
                                <linearGradient
                                  id="paint0_linear_8350_1247"
                                  x1="10.4"
                                  y1="4.66699"
                                  x2="39.375"
                                  y2="4.66699"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  {'\n'}
                                  <stop stopColor="#C8F62E" />
                                  {'\n'}
                                  <stop offset="0.166667" stopColor="#87FB6B" />
                                  {'\n'}
                                  <stop offset="0.333333" stopColor="#3FFA9F" />
                                  {'\n'}
                                  <stop offset="0.5" stopColor="#00F5CC" />
                                  {'\n'}
                                  <stop offset="0.666667" stopColor="#00ECEC" />
                                  {'\n'}
                                  <stop offset="0.833333" stopColor="#48E1FE" />
                                  {'\n'}
                                  <stop offset="1" stopColor="#80D4FF" />
                                  {'\n'}
                                </linearGradient>
                                {'\n'}
                              </defs>
                              {'\n'}
                            </svg>
                          </div>
                          <div className="text-style-tagline">CCPA Ready</div>
                        </div>
                      </div>
                    </div>
                    <div className="layout16_list-wrapper">
                      <div className="layout16_list-item">
                        <div className="w-embed">
                          <svg
                            width="32"
                            height="33"
                            viewBox="0 0 32 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M27.9926 9.86681C27.9704 9.64274 27.8918 9.42795 27.764 9.24256C27.6362 9.05717 27.4635 8.90724 27.2619 8.80681L16.5953 3.47347C16.41 3.38078 16.2057 3.33252 15.9986 3.33252C15.7915 3.33252 15.5872 3.38078 15.4019 3.47347L4.73527 8.80681C4.5343 8.90781 4.36209 9.05793 4.23459 9.24323C4.1071 9.42852 4.02845 9.64301 4.00594 9.86681C3.99127 10.0095 2.72461 24.2228 15.4579 29.8855C15.6281 29.9623 15.8126 30.002 15.9993 30.002C16.1859 30.002 16.3705 29.9623 16.5406 29.8855C29.2739 24.2228 28.0073 10.0108 27.9926 9.86681ZM15.9993 27.1961C6.97394 22.8335 6.54727 13.5228 6.62061 10.8468L15.9993 6.15747L25.3713 10.8441C25.4206 13.4961 24.9339 22.8681 15.9993 27.1961Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                            <path
                              d="M14.666 17.4482L11.6086 14.3909L9.72331 16.2762L14.666 21.2189L22.2753 13.6095L20.39 11.7242L14.666 17.4482Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="layout16_list-text">
                          <h3 className="heading-style-h5 is-list">SOC 2 Type 2 compliant</h3>
                          <p className="text-body-active newhomebody">
                            Audited regularly for compliance with your B2B solution.
                          </p>
                        </div>
                      </div>
                      <div className="layout16_list-item">
                        <div className="w-embed">
                          <svg
                            width="32"
                            height="33"
                            viewBox="0 0 32 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M16.0007 3.3335C12.3247 3.3335 9.33398 6.32416 9.33398 10.0002V12.6668H8.00065C6.52998 12.6668 5.33398 13.8628 5.33398 15.3335V27.3335C5.33398 28.8042 6.52998 30.0002 8.00065 30.0002H24.0007C25.4713 30.0002 26.6673 28.8042 26.6673 27.3335V15.3335C26.6673 13.8628 25.4713 12.6668 24.0007 12.6668H22.6673V10.0002C22.6673 6.32416 19.6767 3.3335 16.0007 3.3335ZM12.0007 10.0002C12.0007 7.79483 13.7953 6.00016 16.0007 6.00016C18.206 6.00016 20.0007 7.79483 20.0007 10.0002V12.6668H12.0007V10.0002ZM24.0033 27.3335H17.334V24.2962C18.1273 23.8335 18.6673 22.9828 18.6673 22.0002C18.6673 20.5295 17.4713 19.3335 16.0007 19.3335C14.53 19.3335 13.334 20.5295 13.334 22.0002C13.334 22.9815 13.874 23.8335 14.6673 24.2962V27.3335H8.00065V15.3335H24.0007L24.0033 27.3335Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="layout16_list-text">
                          <h3 className="heading-style-h5 is-list">Privacy preservation</h3>
                          <p className="text-body-active newhomebody">
                            Your data stays in your control. DBOS never sees your data, and you can keep your data
                            wherever it is safest and most compliant for your use case.
                          </p>
                        </div>
                      </div>
                      <div className="layout16_list-item">
                        <div className="w-embed">
                          <svg
                            width="32"
                            height="33"
                            viewBox="0 0 32 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M22.138 15.3978C22.9501 14.0139 23.3008 12.4075 23.1394 10.8111C22.9007 8.43245 21.5727 6.32978 19.402 4.89111L17.9287 7.11245C19.4207 8.10178 20.3287 9.51111 20.486 11.0778C20.5586 11.8059 20.4679 12.5411 20.2207 13.2298C19.9734 13.9185 19.5758 14.5434 19.0567 15.0591L17.4674 16.6484L19.6247 17.2818C25.2674 18.9351 25.3327 24.6098 25.3327 24.6671H27.9994C27.9994 22.2818 26.7247 17.6204 22.138 15.3978Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                            <path
                              d="M12.666 16.6672C15.6073 16.6672 17.9993 14.2752 17.9993 11.3338C17.9993 8.39249 15.6073 6.00049 12.666 6.00049C9.72468 6.00049 7.33268 8.39249 7.33268 11.3338C7.33268 14.2752 9.72468 16.6672 12.666 16.6672ZM12.666 8.66715C14.1367 8.66715 15.3327 9.86315 15.3327 11.3338C15.3327 12.8045 14.1367 14.0005 12.666 14.0005C11.1953 14.0005 9.99935 12.8045 9.99935 11.3338C9.99935 9.86315 11.1953 8.66715 12.666 8.66715ZM14.666 18.0005H10.666C6.25402 18.0005 2.66602 21.5885 2.66602 26.0005V27.3338H5.33268V26.0005C5.33268 23.0592 7.72468 20.6672 10.666 20.6672H14.666C17.6073 20.6672 19.9993 23.0592 19.9993 26.0005V27.3338H22.666V26.0005C22.666 21.5885 19.078 18.0005 14.666 18.0005Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="layout16_list-text">
                          <h3 className="heading-style-h5 is-list">SSO and SAML</h3>
                          <p className="text-body-active newhomebody">
                            Secure your account with single sign-on and SAML.
                          </p>
                        </div>
                      </div>
                      <div className="layout16_list-item">
                        <div className="w-embed">
                          <svg
                            width="32"
                            height="33"
                            viewBox="0 0 32 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M4 4.66699V27.3337C4 27.6873 4.14048 28.0264 4.39052 28.2765C4.64057 28.5265 4.97971 28.667 5.33333 28.667H28V26.0003H6.66667V4.66699H4Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                            <path
                              d="M20.3907 20.2763C20.5144 20.4002 20.6614 20.4985 20.8231 20.5656C20.9849 20.6327 21.1583 20.6672 21.3334 20.6672C21.5085 20.6672 21.6819 20.6327 21.8436 20.5656C22.0054 20.4985 22.1523 20.4002 22.276 20.2763L28.9427 13.6096L27.0574 11.7243L21.3334 17.4483L18.276 14.391C18.1523 14.267 18.0054 14.1687 17.8436 14.1016C17.6819 14.0345 17.5085 14 17.3334 14C17.1583 14 16.9849 14.0345 16.8231 14.1016C16.6614 14.1687 16.5144 14.267 16.3907 14.391L9.72404 21.0576L11.6094 22.943L17.3334 17.219L20.3907 20.2763Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="layout16_list-text">
                          <h3 className="heading-style-h5 is-list">Runs at scale</h3>
                          <p className="text-body-active newhomebody">
                            DBOS has been put to the test and designed to scale so your team can just focus on building
                            a great product.
                          </p>
                        </div>
                      </div>
                      <div className="layout16_list-item">
                        <div className="w-embed">
                          <svg
                            width="32"
                            height="33"
                            viewBox="0 0 32 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M19.9993 3.35107H11.9993V12.6671H2.66602V20.6671H11.9993V29.9831H19.9993V20.6671H29.3327V12.6671H19.9993V3.35107Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="layout16_list-text">
                          <h3 className="heading-style-h5 is-list">HIPAA BAA Available</h3>
                          <p className="text-body-active newhomebody">
                            DBOS has been built with healthcare in mind to handle sensitive data.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SlideIn>
        </section>
      </div>
    </SiteLayout>
  );
}
